<template>
  <h3 class="font-semibold leading-default text-subtitle text-2xl 2xs:text-3xl xs:text-4xl hd:text-[2.5rem] mb-6 animate-top">
    <slot />
  </h3>
</template>
